import { DataValidationKinds } from "../DataValidationKinds";
import { IItem } from "./IItem";
import { INameDisplayable, instanceOfINameDisplayable } from "./INameDisplayable";

export interface ITextValidatable extends IItem, INameDisplayable {
  text(): string;
  shouldValidateText(): boolean;
  dataValidationKind: DataValidationKinds;
}

export function instanceOfITextValidatable(instance: any): instance is ITextValidatable {
  return instance
    && (instance.text !== undefined)
    && (instance.shouldValidateText !== undefined)
    && (instance.dataValidationKind !== undefined)
    && instanceOfINameDisplayable(instance);
}
